import { render } from "./App.vue?vue&type=template&id=3f9fd0d0&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=3f9fd0d0&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\mytransfers-extranet-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f9fd0d0"]])

export default __exports__